import React, { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import SEO from "./components/SEO";
import Pdf from "./components/Pdf";
import { getDomainType, shouldRedirectToDomain } from "./utils/domainRouter";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Blogs from "./pages/Blogs";
import ContactUs from "./pages/ContactUs";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Rooms from "./pages/Rooms";
import Ayurveda from "./pages/Ayurveda";
import Yoga from "./pages/Yoga";
import Food from "./pages/Food";
import Events from "./pages/Events";
import Tours from "./pages/Tours";
import DeluxeRoom from "./pages/DeluxeRoom";
import SuiteRoom from "./pages/SuiteRoom";
import DeluxeRoomwithSeaView from "./pages/DeluxeSeaViewRoom";
import Search from "./BookingBeach/Search";
import Booking from "./BookingBeach/Booking";
import Checkout from "./BookingBeach/Checkout";
import Confirmation from "./BookingBeach/Confirmation";
import Open from "./pages/Open";

import Navbar2 from "./components/Navbar2";
import Footer2 from "./components/Footer2";
import Home2 from "./pages/Home2";
import AboutUs2 from "./pages/AboutUs2";
import ContactUs2 from "./pages/Contact2";
import Blogs2 from "./pages/Blogs2";
import RoomsPage2 from "./pages/Rooms2";
import Ayurveda2 from "./pages/Ayurveda2";
import Yoga2 from "./pages/Yoga2";
import Food2 from "./pages/Food2";
import Events2 from "./pages/Events2";
import Tours2 from "./pages/Tours2";
import DeluxeRoom2 from "./pages/DeluxeRoom2";
import DeluxeRiverViewRoom from "./pages/DeluxeRiverViewRoom";
import Search2 from "./BookingRiver/Search2";
import Booking2 from "./BookingRiver/Booking2";
import Checkout2 from "./BookingRiver/Checkout2";
import Confirmation2 from "./BookingRiver/Confirmation2";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname || '/';
  const domainType = getDomainType();

  // Handle domain-based routing on mount and route changes
  useEffect(() => {
    // Check if we need to redirect to a different domain
    const redirectUrl = shouldRedirectToDomain();
    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    // Auto-redirect based on domain
    if (domainType === 'beach' && path === '/') {
      // Beach domain root should go directly to /beach/home
      navigate('/beach/home', { replace: true });
    } else if (domainType === 'beach' && !path.startsWith('/beach')) {
      // Any other path on beach domain should redirect to beach routes
      navigate('/beach/home', { replace: true });
    } else if (domainType === 'river' && path === '/') {
      // River domain root should go directly to /river/home
      navigate('/river/home', { replace: true });
    } else if (domainType === 'river' && !path.startsWith('/river')) {
      // Any other path on river domain should redirect to river routes
      navigate('/river/home', { replace: true });
    } else if (domainType === 'main' && path === '/') {
      // On main domain root, show the Open (selection) page
      navigate('/', { replace: true });
    }
  }, [domainType, path, navigate]);

  // More powerful, keyword-optimized, route-specific SEO
  let seoProps = { pathname: path };

  if (path === '/' || path.startsWith('/')) {
    seoProps = {
      ...seoProps,
      title: 'Muthumuni Ayurveda Resorts — Best Authentic Ayurveda Beach & River Resorts in Sri Lanka',
      description: 'Experience genuine Ayurveda healing in Sri Lanka at Muthumuni Resorts: beachfront wellness in Beruwala and tranquil river retreat in Aluthgama. Traditional treatments, Panchakarma, yoga, detox & organic food.',
      keywords: 'best ayurveda resort sri lanka, muthumuni ayurveda, ayurveda beruwala, ayurveda aluthgama, panchakarma sri lanka, wellness retreat sri lanka',
    };
  } else if (path.startsWith('/beach')) {
    seoProps = {
      ...seoProps,
      title:
        path.includes('deluxe-sea-view')
          ? 'Deluxe Sea View Room – Muthumuni Ayurveda Beach Resort Beruwala'
          : path.includes('luxury-suite')
            ? 'Luxury Suite – Muthumuni Ayurveda Beach Resort Beruwala Sri Lanka'
            : path.includes('deluxe')
              ? 'Deluxe Room – Muthumuni Ayurveda Beach Resort Beruwala'
              : 'Muthumuni Ayurveda Beach Resort Beruwala – Authentic Ayurveda by the Sea',
      description:
        'Traditional Ayurveda therapies, beach yoga, Panchakarma detox, herbal treatments and oceanfront relaxation at Muthumuni Ayurveda Beach Resort in Beruwala, Sri Lanka. Book your wellness holiday now.',
      url: 'https://muthumuniayurvedaresorts.com/beach/home',
    };
  } else if (path.startsWith('/river')) {
    seoProps = {
      ...seoProps,
      title:
        path.includes('deluxe-river-view-room')
          ? 'Deluxe River View Room – Muthumuni Ayurveda River Resort Aluthgama'
          : path.includes('deluxe-room')
            ? 'Deluxe Room – Muthumuni Ayurveda River Resort Aluthgama Sri Lanka'
            : 'Muthumuni Ayurveda River Resort Aluthgama – Peaceful Riverside Ayurveda Retreat',
      description:
        'Tranquil riverfront Ayurveda in Aluthgama: authentic Panchakarma, nature-based therapies, riverside yoga, detox programs and organic cuisine near Bentota. Rejuvenate in serenity.',
      url: 'https://muthumuniayurvedaresorts.com/river/home',
    };
  }

  return (
    <div>
      <SEO {...seoProps} />
      <Pdf />
      <Routes>
        <Route path="/" element={<Open />} />
        <Route
          path="/beach/*"
          element={
            <div>
              <Navbar />
              <Routes>
                <Route path="/home" element={<Home />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="rooms" element={<Rooms />} />
                <Route path="ayurveda" element={<Ayurveda />} />
                <Route path="yoga" element={<Yoga />} />
                <Route path="food" element={<Food />} />
                <Route path="events" element={<Events />} />
                <Route path="tours" element={<Tours />} />
                <Route path="rooms/deluxe" element={<DeluxeRoom />} />
                <Route path="rooms/luxury-suite" element={<SuiteRoom />} />
                <Route path="rooms/deluxe-sea-view" element={<DeluxeRoomwithSeaView />} />
              </Routes>
              <Footer />
            </div>
          }
        />

        <Route
          path="/beach/search"
          element={
            <div>
              <Search />
              <Footer />
            </div>
          }
        />
        <Route
          path="/beach/booking"
          element={
            <div>
              <Booking />
              <Footer />
            </div>
          }
        />
        <Route
          path="/beach/checkout"
          element={
            <div>
              <Checkout />
              <Footer />
            </div>
          }
        />
        <Route
          path="/beach/confirmation"
          element={
            <div>
              <Confirmation />
              <Footer />
            </div>
          }
        />
        <Route
          path="/river/*"
          element={
            <div>
              <Navbar2 />
              <Routes>
                <Route path="home" element={<Home2 />} />
                <Route path="about-us" element={<AboutUs2 />} />
                <Route path="contact-us" element={<ContactUs2 />} />
                <Route path="blogs" element={<Blogs2 />} />
                <Route path="rooms" element={<RoomsPage2 />} />
                <Route path="ayurveda" element={<Ayurveda2 />} />
                <Route path="yoga" element={<Yoga2 />} />
                <Route path="food" element={<Food2 />} />
                <Route path="events" element={<Events2 />} />
                <Route path="tours" element={<Tours2 />} />
                <Route path="rooms/deluxe-room" element={<DeluxeRoom2 />} />
                <Route path="rooms/deluxe-river-view-room" element={<DeluxeRiverViewRoom />} />
              </Routes>
              <Footer2 />
            </div>
          }
        />
        <Route
          path="/river/search"
          element={
            <div>
              <Search2 />
              <Footer2 />
            </div>
          }
        />
        <Route
          path="/river/booking"
          element={
            <div>
              <Booking2 />
              <Footer2 />
            </div>
          }
        />
        <Route
          path="/river/checkout"
          element={
            <div>
              <Checkout2 />
              <Footer2 />
            </div>
          }
        />
        <Route
          path="/river/confirmation"
          element={
            <div>
              <Confirmation2 />
              <Footer2 />
            </div>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
